export default __webpack_public_path__ + "static/media/infoGrey.f202e39b.svg";